(function($) {
var $ = jQuery.noConflict();
$(document).on('ready', function() {
	
	
	$('.accordion .toggle').click(function(e) {
		e.preventDefault();
		$('.accordion li a').each(function() {
			$(this).removeClass('active');
		});
		var $this = $(this);
		if ($this.next().hasClass('show')) {
			$this.next().removeClass('show');
			$this.next().slideUp(350);
		} else {
			$this.parent().parent().find('li .inner').removeClass('show');
			$this.parent().parent().find('li .inner').slideUp(350);
			$this.toggleClass('active');
			$this.next().toggleClass('show');
			$this.next().slideToggle(350);
		}
	});
	

	

const plays = document.querySelectorAll('.play');

plays.forEach(playss => {
	playss.addEventListener('mouseenter', () => {
		playss.style.visibility = "hidden";
	});
	playss.addEventListener('pointerenter', () => {
		playss.style.visibility = "hidden";
	});
	const videos = document.querySelectorAll('.video_prev');

	videos.forEach(video => {
		
		video.addEventListener('mouseenter', () => {
			video.play();
			video.volume = 0;
			//video.currentTime = 0;
		});
		
		video.addEventListener('mouseleave', () => {
			video.pause();
			playss.style.visibility = "visible";
		});
		
		video.addEventListener('click', () => {
			$('.openVideo').magnificPopup({
				type: 'inline',
				closeOnContentClick: false,
				closeBtnInside: true,
				fixedContentPos: true,
				mainClass: 'my-custom-class',
				callbacks: {
					open: function() {
						const firstVideo = $(this.content).find('video')[0];
						//firstVideo.currentTime = video.currentTime;
						firstVideo.play();
						$('#sec_4 #video_testi').slick('slickPause');
					},
					close: function() {
						const firstVideo = $(this.content).find('video')[0];
						firstVideo.pause();
						$('#sec_4 #video_testi').slick('slickPlay');
					}
				}
			});
		});
	});
});


function resize() {
    var itemWidth = $('#video_testi .item').width(); 
	$('.video_prev').each(function() {
		$(this).css({'width': '100%','height': '100%'});
	});

}

resize();
window.onresize = resize;

	if($("#sec_4 #video_testi").length > 0){
		$('#sec_4 #video_testi').slick({
			dots: false,
			speed: 800,
			slidesToShow: 2,
			slidesToScroll: 1,
			adaptiveHeight: false,
			infinite: true,
			pauseOnHover: false,
			pauseOnFocus: false,
			autoplay: true,
			cssEase: 'linear',
			useCSS: true,
			useTransform: true,
			autoplaySpeed: 4000,
			arrows: true,
			prevArrow: '<i class="arrow left"></i>',
			nextArrow: '<i class="arrow right"></i>',
			mobileFirst: true,
			responsive: [
			{
				breakpoint: 811,
				settings: "unslick"
			},
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 1
				}
			 },
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2
				}
			 }
			]
		});
	}
	
	if($("#sec_3 .row").length > 0){
		$('#sec_3 .row').slick({
			dots: false,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			infinite: true,
			pauseOnHover: false,
			pauseOnFocus: false,
			autoplay: true,
			cssEase: 'linear',
			useCSS: true,
			useTransform: true,
			autoplaySpeed: 4000,
			arrows: true,
			prevArrow: '<i class="arrow left"></i>',
			nextArrow: '<i class="arrow right"></i>',
			mobileFirst: true,
			responsive: [
			 {
				breakpoint: 480,
				settings: "unslick"
			 }
			]
		});
	}
	
	
	
	
	
	
/*

$('.openVideo').magnificPopup({
	type: 'inline',
	closeOnContentClick: false,
	closeBtnInside: true,
	fixedContentPos: true,
	mainClass: 'my-custom-class',
	callbacks: {
		open: function() {
		// Play video on open:
			const firstVideo = $(this.content).find('video')[0];
			firstVideo.currentTime = video.currentTime;
			firstVideo.play()
		},
		close: function() {
		// Reset video on close:
			$(this.content).find('video')[0].pause();
		//$(this.content).find('video')[0].load();
		}
	}
});

*/

});
})(jQuery);